<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{
        show:
          isShowNghiViecSidebar ||
          isShowBienDongDenSidebar ||
          isShowBienDongDiSidebar,
      }"
      @click="
        isShowNghiViecSidebar =
          isShowBienDongDenSidebar =
          isShowBienDongDiSidebar =
            false
      "
    />
    <filters
      :options="donVis"
      :default-option.sync="donViFilter"
      :is-loaded="dataTableIsLoaded"
      @fetch-data="fetchData"
    />

    <nghi-viec-sidebar
      :is-show-sidebar.sync="isShowNghiViecSidebar"
      :cbccvc-detail="cbccvcDetail"
      @update-trang-thai-nghi-viec="UpdateTrangThaiNghiViec"
    />

    <bien-dong-di-sidebar
      :don-vi-default-selected.sync="donViFilter"
      :is-show-sidebar.sync="isShowBienDongDiSidebar"
      :cbccvc-detail="cbccvcDetail"
      @update-trang-thai-bien-dong-di="UpdateTrangThaiBienDongDi"
      @refetch-data="reLoadDataTable"
    />

    <bien-dong-den-sidebar
      :don-vis="donVis"
      :don-vi-default-selected.sync="donViFilter"
      :is-show-sidebar.sync="isShowBienDongDenSidebar"
      :cbccvc-detail="cbccvcDetail"
      @update-trang-thai-bien-dong-den="UpdateTrangThaiBienDongDen"
      @refetch-data="reLoadDataTable"
    />

    <b-card no-body>
      <b-card-body>
        <b-tabs :active-tab="activeTab" nav-class="cs-b-tab">
          <b-tab title="Biến động đến" name="bienDongDen" @click="handleTabClick('bienDongDen')">
            <template #title>
              <feather-icon icon="ArrowDownRightIcon" />
              <span>Biến động đến</span>
            </template>
            <b-overlay :show="dataTableIsLoaded" rounded="sm" no-fade>
              <data-table-bien-dong-den
                :data-table="listBienDongDen"
                :search-ref.sync="searchTermBienDongDen"
                :is-loaded="dataTableIsLoaded"
                @show-edit="showBienDongDenSlidebar"
                @remove-item="removeTrangThaiBienDongDen"
                @update-pagination="updatePaginationBienDongDen"
                @update-perpage="updatePerPageBienDongDen"
                :total-rows="totalRowsBienDongDen"
              />
            </b-overlay>
          </b-tab>
          <b-tab title="Biến động đi" name="bienDongDi" @click="handleTabClick('bienDongDi')">
            <template #title>
              <feather-icon icon="ArrowUpRightIcon" />
              <span>Biến động đi</span>
            </template>
            <b-overlay :show="dataTableIsLoaded" rounded="sm" no-fade>
              <data-table-bien-dong-di
                :data-table="listBienDongDi"
                :search-ref.sync="searchTermBienDongDi"
                :is-loaded="dataTableIsLoaded"
                @show-edit="showBienDongDiSlidebar"
                @remove-item="removeTrangThaiBienDongDi"
                @update-pagination="updatePaginationBienDongDi"
                @update-perpage="updatePerPageBienDongDi"
                :total-rows="totalRowsBienDongDi"
              />
            </b-overlay>
          </b-tab>

          <b-tab title="Danh sách nghỉ việc" name="nghiViec" @click="handleTabClick('nghiViec')">
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Danh sách nghỉ việc</span>
            </template>
            <b-overlay :show="dataTableIsLoaded" rounded="sm" no-fade>
              <data-table-nghi-viec
                :data-table="listNghiViec"
                :search-ref.sync="searchTermNghiViec"
                :is-loaded="dataTableIsLoaded"
                @show-edit="showNghiViecSlidebar"
                @remove-item="removeTrangThaiNghiViec"
                @update-pagination="updatePaginationNghiViec"
                @update-perpage="updatePerPageNghiViec"
                :total-rows="totalRowsNghiViec"
              />
            </b-overlay>
          </b-tab>
          <b-tab title="Hồ sơ đã xóa" name="daXoa" @click="handleTabClick('daXoa')">
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Hồ sơ đã xóa</span>
            </template>
            <b-overlay :show="dataTableIsLoaded" rounded="sm" no-fade>
              <data-table-ho-so-da-xoa
                :data-table="listDaXoa"
                :search-ref.sync="searchTermDaXoa"
                :is-loaded="dataTableIsLoaded"
                @remove-item="removeTrangThaiDaXoa"
                @update-pagination="updatePaginationDaXoa"
                @update-perpage="updatePerPageDaXoa"
                :total-rows="totalRowsDaXoa"
              />
            </b-overlay>
          </b-tab>
          <b-tab title="Chuyển Khối đảng - Đoàn thể - Mặt trận" name="khoiDang" @click="handleTabClick('khoiDang')">
            <template #title>
              <feather-icon icon="UserIcon" />
              <span>Chuyển Khối đảng - Đoàn thể - Mặt trận</span>
            </template>
            <b-overlay :show="dataTableIsLoaded" rounded="sm" no-fade>
              <data-table-khoi-dang
                :data-table="listKhoiDang"
                :search-ref.sync="searchTermKhoiDang"
                :is-loaded="dataTableIsLoaded"
                @remove-item="removeKhoiDang"
                @update-pagination="updatePaginationKhoiDang"
                @update-perpage="updatePerPageKhoiDang"
                :total-rows="totalRowsKhoiDang"
              />
            </b-overlay>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable */
import LayoutData from "@/layouts/LayoutData";
import { BOverlay } from "bootstrap-vue";
import {
  BTabs,
  BTab,
  BCard,
  BCardHeader,
  BCardBody,
  BCardText,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/HoSoCanBoCongChuc/CanBoCongChucService";

import Filters from "./components/Filters.vue";
import RightSidebar from "./components/RightSidebar.vue";
import DataTableBienDongDen from "./components/DataTableBienDongDen.vue";
import DataTableBienDongDi from "./components/DataTableBienDongDi.vue";
import DataTableNghiViec from "./components/DataTableNghiViec.vue";
import DataTableHoSoDaXoa from "./components/DataTableHoSoDaXoa.vue";
import DataTableKhoiDang from "./components/DataTableKhoiDang.vue";
import NghiViecSidebar from "./components/NghiViecSidebar.vue";
import BienDongDiSidebar from "./components/BienDongDiSidebar.vue";
import BienDongDenSidebar from "./components/BienDongDenSidebar.vue";

import useSetup from "./useSetup";

export default {
  directives: {
    Ripple,
  },
  components: {
    Filters,
    RightSidebar,
    DataTableBienDongDen,
    DataTableBienDongDi,
    DataTableNghiViec,
    DataTableHoSoDaXoa,
    DataTableKhoiDang,
    NghiViecSidebar,
    BienDongDiSidebar,
    BienDongDenSidebar,
    BCard,
    BCardHeader,
    BCardBody,
    BCardText,
    BTabs,
    BTab,
    BOverlay,
  },
  data() {
    return {
      isWait: false,
    };
  },
  watch: {},
  methods: {},
  created() {},
  setup(props, { emit }) {
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Biến động cán bộ công chức";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;

    const activeTab = ref('bienDongDen'); // Tab hiện tại

    const listBienDongDen = ref([]);
    const listNghiViec = ref([]);
    const listBienDongDi = ref([]);
    const listDaXoa = ref([]);
    const listKhoiDang = ref([]);

    // Khai báo các biến phân trang cho từng tab
    const currentPageBienDongDen = ref(1);
    const perPageBienDongDen = ref(10);
    const totalRowsBienDongDen = ref(0);

    const currentPageBienDongDi = ref(1);
    const perPageBienDongDi = ref(10);
    const totalRowsBienDongDi = ref(0);

    const currentPageNghiViec = ref(1);
    const perPageNghiViec = ref(10);
    const totalRowsNghiViec = ref(0);

    const currentPageDaXoa = ref(1);
    const perPageDaXoa = ref(10);
    const totalRowsDaXoa = ref(0);

    const currentPageKhoiDang = ref(1);
    const perPageKhoiDang = ref(10);
    const totalRowsKhoiDang = ref(0);

    const {
      // getDataList,
      getDataBienDongDi,
      getDataBienDongDen,
      getDataNghiViec,
      getDataDaXoa,
      getDataKhoiDang,
      getDonVi,
      // donVis,
      perPage,
      currentPage,
      perPageOptions,
    } = useSetup();

    const donViFilter = ref(null);
    const donVis = ref([]);
    getDonVi({}, (data) => {
      donVis.value = data;
      if (data.length > 0) {
        filters.donVi = data[0];
      }
    });
    const dataTableIsLoaded = ref(false);

    const cbccvcDetail = ref({
      donVi: {},
    });
    const tieuChis = ref(null);
    const fetchData = (filters) => {
      tieuChis.value = filters;
      dataTableIsLoaded.value = true;
      donViFilter.value = filters.donVi;

      const commonCondition = {
        isChildren: filters.isChildren ? filters.isChildren : false,
        donViId: donViFilter.value ? donViFilter.value.id : "",
      };

      // Tải dữ liệu theo tab hiện tại
      const loadTabData = {
        bienDongDen: () => {
          const conditionBienDongDen = {
            ...commonCondition,
            start: currentPageBienDongDen.value,
            limit: perPageBienDongDen.value,
          };
          getDataBienDongDen(conditionBienDongDen, (data) => {
            dataTableIsLoaded.value = false;
            listBienDongDen.value = data.data ? data.data : [];
            totalRowsBienDongDen.value = data.totalRows;
          });
        },
        bienDongDi: () => {
          const conditionBienDongDi = {
            ...commonCondition,
            start: currentPageBienDongDi.value,
            limit: perPageBienDongDi.value,
          };
          getDataBienDongDi(conditionBienDongDi, (data) => {
            dataTableIsLoaded.value = false;
            listBienDongDi.value = data.data ? data.data : [];
            totalRowsBienDongDi.value = data.totalRows;
          });
        },
        nghiViec: () => {
          const conditionNghiViec = {
            ...commonCondition,
            start: currentPageNghiViec.value,
            limit: perPageNghiViec.value,
          };
          getDataNghiViec(conditionNghiViec, (data) => {
            dataTableIsLoaded.value = false;
            listNghiViec.value = data.data ? data.data : [];
            totalRowsNghiViec.value = data.totalRows;
          });
        },
        daXoa: () => {
          const conditionDaXoa = {
            ...commonCondition,
            start: currentPageDaXoa.value,
            limit: perPageDaXoa.value,
          };
          getDataDaXoa(conditionDaXoa, (data) => {
            dataTableIsLoaded.value = false;
            listDaXoa.value = data.data ? data.data : [];
            totalRowsDaXoa.value = data.totalRows;
          });
        },
        khoiDang: () => {
          const conditionKhoiDang = {
            ...commonCondition,
            start: currentPageKhoiDang.value,
            limit: perPageKhoiDang.value,
          };
          getDataKhoiDang(conditionKhoiDang, (data) => {
            dataTableIsLoaded.value = false;
            listKhoiDang.value = data.data ? data.data : [];
            totalRowsKhoiDang.value = data.totalRows;
          });
        },
      };

      // Gọi hàm tải dữ liệu cho tab hiện tại
      if (loadTabData[activeTab.value]) {
        // console.log(`Gọi hàm tải dữ liệu cho tab: ${activeTab.value}`);
        loadTabData[activeTab.value](); // Gọi hàm tương ứng với tab hiện tại
      } else {
        console.error(`Tab "${activeTab.value}" không tồn tại hoặc chưa được xử lý.`);
      }
    };

    // Hàm xử lý khi chuyển tab
    const handleTabClick = (tabName) => {
      if (activeTab.value !== tabName) {
        activeTab.value = tabName;
        // console.log("Chuyen den tab:", tabName);
        fetchData(tieuChis.value);
      }
    };

    const updatePaginationBienDongDen = (page) => {
      currentPageBienDongDen.value = page;
      fetchData(tieuChis.value);
    };

    const updatePerPageBienDongDen = (perPage) => {
      perPageBienDongDen.value = perPage;
      fetchData(tieuChis.value);
    };

    const updatePaginationBienDongDi = (page) => {
      currentPageBienDongDi.value = page;
      fetchData(tieuChis.value);
    };

    const updatePerPageBienDongDi = (perPage) => {
      perPageBienDongDi.value = perPage;
      fetchData(tieuChis.value);
    };

    const updatePaginationNghiViec = (page) => {
      currentPageNghiViec.value = page;
      fetchData(tieuChis.value);
    };

    const updatePerPageNghiViec = (perPage) => {
      perPageNghiViec.value = perPage;
      fetchData(tieuChis.value);
    };

    const updatePaginationDaXoa = (page) => {
      currentPageDaXoa.value = page;
      fetchData(tieuChis.value);
    };

    const updatePerPageDaXoa = (perPage) => {
      perPageDaXoa.value = perPage;
      fetchData(tieuChis.value);
    };

    const updatePaginationKhoiDang = (page) => {
      currentPageKhoiDang.value = page;
      fetchData(tieuChis.value);
    };

    const updatePerPageKhoiDang = (perPage) => {
      perPageKhoiDang.value = perPage;
      fetchData(tieuChis.value);
    };

    const searchTermNghiViec = ref({ value: "" });
    const searchTermDaXoa = ref({ value: "" });
    const searchTermKhoiDang = ref({ value: "" });
    const isShowNghiViecSidebar = ref(false);
    const showNghiViecSlidebar = (data, id) => {
      isShowNghiViecSidebar.value = true;
      cbccvcDetail.value = JSON.parse(JSON.stringify(data));
    };
    const removeTrangThaiNghiViec = (item) => {
      var index = listNghiViec.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        listNghiViec.value.splice(index, 1);
      }
    };
    const removeTrangThaiDaXoa = (item) => {
      var index = listDaXoa.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        listDaXoa.value.splice(index, 1);
      }
    };
    const removeKhoiDang = (item) => {
      var index = listKhoiDang.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        listKhoiDang.value.splice(index, 1);
      }
    };

    const UpdateTrangThaiNghiViec = (tinhTrangNghiViec) => {
      let index = listNghiViec.value.findIndex((el) => {
        if (!el.tinhTrangNghiViec) return false;
        return el.tinhTrangNghiViec.id == tinhTrangNghiViec.oldId;
      });
      if (index != -1) {
        listNghiViec.value[index].tinhTrangNghiViec = tinhTrangNghiViec;
      }
    };

    const searchTermBienDongDen = ref({ value: "" });
    const isShowBienDongDenSidebar = ref(false);
    const showBienDongDenSlidebar = (data, id) => {
      isShowBienDongDenSidebar.value = true;
      cbccvcDetail.value = JSON.parse(JSON.stringify(data));
    };
    const removeTrangThaiBienDongDen = (item) => {
      let index = listBienDongDen.value.findIndex((el) => {
        if (!el.bienDong) return false;
        return el.bienDong.id == item.bienDong.id;
      });
      if (index != -1) {
        listBienDongDen.value.splice(index, 1);
      }
    };
    const UpdateTrangThaiBienDongDen = (tinhTrangBienDongDen) => {
      let index = listBienDongDen.value.findIndex((el) => {
        if (!el.bienDong) return false;
        return el.bienDong.id == tinhTrangBienDongDen.id;
      });
      if (index != -1) {
        listBienDongDen.value.splice(index, 1);
      }
    };

    const searchTermBienDongDi = ref({ value: "" });
    const isShowBienDongDiSidebar = ref(false);
    const showBienDongDiSlidebar = (data, id) => {
      isShowBienDongDiSidebar.value = true;
      cbccvcDetail.value = JSON.parse(JSON.stringify(data));
    };
    const removeTrangThaiBienDongDi = (item) => {
      var index = listBienDongDi.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        listBienDongDi.value.splice(index, 1);
      }
    };
    const UpdateTrangThaiBienDongDi = (data) => {
      let index = listBienDongDi.value.findIndex((el) => {
        if (!el.bienDong) return false;
        return el.bienDong.id == data.id;
      });
      if (index != -1) {
        listBienDongDi.value[index].bienDong = data;
      }
    };
    //After select
    const reLoadDataTable = () => {
      console.log("fetchData: ", filters)
      fetchData(tieuChis.value);
    };

    const removeItem = (item) => {
      var index = dataTable.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        dataTable.value.splice(index, 1);
      }
    };

    const pagination = (value) => {
      
      currentPage.value = value;

    };

    const perpage = (value) => {
      perPage.value = value;
    };

    watch([currentPage, perPage], () => {
      fetchData(tieuChis.value);
    });

    return {
      donVis,
      donViFilter,
      fetchData,
      dataTableIsLoaded,
      getDonVi,
      listNghiViec,
      searchTermNghiViec,
      isShowNghiViecSidebar,
      showNghiViecSlidebar,
      UpdateTrangThaiNghiViec,
      removeTrangThaiNghiViec,

      listBienDongDen,
      searchTermBienDongDen,
      isShowBienDongDenSidebar,
      showBienDongDenSlidebar,
      UpdateTrangThaiBienDongDen,
      removeTrangThaiBienDongDen,

      listBienDongDi,
      searchTermBienDongDi,
      isShowBienDongDiSidebar,
      showBienDongDiSlidebar,
      UpdateTrangThaiBienDongDi,
      removeTrangThaiBienDongDi,

      listDaXoa,
      searchTermDaXoa,
      removeTrangThaiDaXoa,

      listKhoiDang,
      searchTermKhoiDang,
      removeKhoiDang,

      tieuChis,
      cbccvcDetail,
      pagination,
      reLoadDataTable,
      removeItem,

      // Các biến totalRows riêng biệt
      currentPageBienDongDen,
      perPageBienDongDen,
      totalRowsBienDongDen,
      currentPageBienDongDi,
      perPageBienDongDi,
      totalRowsBienDongDi,
      currentPageNghiViec,
      perPageNghiViec,
      totalRowsNghiViec,
      currentPageDaXoa,
      perPageDaXoa,
      totalRowsDaXoa,
      currentPageKhoiDang,
      perPageKhoiDang,
      totalRowsKhoiDang,
      updatePaginationBienDongDen,
      updatePerPageBienDongDen,
      updatePaginationBienDongDi,
      updatePerPageBienDongDi,
      updatePaginationNghiViec,
      updatePerPageNghiViec,
      updatePaginationDaXoa,
      updatePerPageDaXoa,
      updatePaginationKhoiDang,
      updatePerPageKhoiDang,

      activeTab,
      handleTabClick,
      perpage,
      perPage,
      currentPage,
      perPageOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
.biendong-sidebar,
#nghi-viec-sidebar {
  width: 50% !important;
}
</style>
